export enum CupsAndLidsType {
    Standard = 1,
    Reserve = 2,
    EcoCompostable = 3,
  }